import React from "react";
import { useState, useEffect } from "react";
import styles from "./faqMain.module.css";

import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import { getAllFaqsApi } from "../../../config/getAllFaqsApi";

function FaqMain() {
  const [toggleState, setToggleState] = useState(0);
  const [loader, setLoader] = useState(true);
  const [allTabs, setAllTabs] = useState([]);
  const [allConts, setAllConts] = useState([]);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  useEffect(() => {
    const faqs = async () => {
      const faq = await getAllFaqsApi();

      if (faq.data) {
        setAllTabs([]);
        setAllConts([]);
        setLoader(false);
        faq.data.data.map((value, index) => {
          setAllTabs((allTabs) => [...allTabs, value.question_type]);
          
          setAllConts((allConts) => [
            ...allConts,value.faqs 
          ]);
        });
      } else if (faq.error) {
        console.log(faq.error);
        setLoader(false);
      }
    };
    faqs();
  }, []);
  
  return (
    <>
      {loader ? (
        <>
          <h2 className={styles.head}>Frequently asked questions</h2>
        <div className={styles.loader}>
        <div className="spinner-border" role="status"></div>
        </div>
        </>
      ) : (
        <div className={styles.container}>
          <h2 className={styles.head}>Frequently asked questions</h2>
          <div className={styles.bloctabs}>
            {allTabs.map((value, index) => (
              <button
                key={index}
                className={
                  toggleState === index ? styles.activetabs : styles.tabs
                }
                onClick={() => toggleTab(index)}
              >
                {value}
              </button>
            ))}
          </div>

          <div className={styles.contenttabs}>
            {allConts.map((value, index) => (
              <div
                key={index}
                className={
                  toggleState === index ? styles.activecontent : styles.content
                }
              >
                <SimpleAccordion data={value} />
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}

export default FaqMain;

function SimpleAccordion({ data }) {
  return (
    <div className={styles.root}>
      {data.map((value, index) => (
        <Accordion style={{ backgroundColor: "#fafafa" }} key={index}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <h1 className={styles.faqHead}>{value.question}</h1>
          </AccordionSummary>
          <AccordionDetails>
            <p className={styles.faqDes}>{value.answer}</p>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
}
